import { axios } from '@/utils/axios';

const RESOURCE_NAME  = '/organization-contact';

export default {
    get() {
        return axios.get(`${RESOURCE_NAME}/`)
    },
    create(payload) {
        return axios.post(`${RESOURCE_NAME}/`, payload)
    },
    update(payload) {
        return axios.post(`${RESOURCE_NAME}/update`, payload)
    },
    remove(payload) {
        return axios.post(`${RESOURCE_NAME}/remove`, { organization_contact_id: payload })
    }
};